import { faReply, faReplyAll, faShare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { v4 as uuid } from "uuid";
import { apiFetch } from "../../../app/apiClient";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { activeFolder, activeEmail, composeEmail } from "../../inbox/emailSlice";
import ComponentLoading from "../../../components/ComponentLoading";
import { currentToken } from "../../login/loginSlice";
import EmailBody from "./EmailBody";
import { buildForwardedBody, buildForwardSubject, buildQuotedReplyBody, buildReplySubject } from "./replyUtils";

function PreviewPane() {
    let dispatch = useAppDispatch();
    let [currentLoadingEvents, setCurrentLoadingEvents] = useState(0);
    let appMessage = useAppSelector(activeEmail);
    let appFolder = useAppSelector(activeFolder);
    let userToken = useAppSelector(currentToken);
    let [emailTitle, setEmailTitle] = useState("Select an Email to View");
    let [fromComponent, setFromComponent] = useState(<></>);
    let [emailComponent, setEmailComponent] = useState(<></>);
    let [currentMessage, setCurrentMessage] = useState<any>(null);

    useEffect(() => {
        if (!appMessage) {
            setEmailTitle("Select an Email to View");
            setFromComponent(<></>);
            setEmailComponent(<></>);
            setCurrentMessage(null);
            return;
        }

        const abortController = new AbortController();
        setCurrentLoadingEvents(1);
        apiFetch("/api/email/" + appFolder! + "/" + appMessage, {
            method: "GET",
            token: userToken,
            signal: abortController.signal
        }).then((data) => {
            return data.json();
        }).then((data) => {
            setEmailTitle(data.email.subject || "(No Subject)");
            setFromComponent(<div className={"addressComponent"}>
                <strong>From: {data.email.from.text}</strong>
            </div>);
            setEmailComponent(<EmailBody html={data.email.body.html} text={data.email.body.text} />);
            setCurrentMessage(data.email);
            setCurrentLoadingEvents(0);
        }).catch((error) => {
            if (error.name === "AbortError" || error.name === "SessionExpiredError") return;
            setCurrentMessage(null);
            setCurrentLoadingEvents(0);
        });

        return () => abortController.abort();
    }, [appMessage, appFolder, userToken]);

    const handleReply = () => {
        dispatch(composeEmail({
            guid: uuid(),
            to: currentMessage.from?.text || "",
            subject: buildReplySubject(currentMessage.subject),
            body: buildQuotedReplyBody(currentMessage),
            header: "Reply"
        }));
    };

    const handleReplyAll = () => {
        const cc = [currentMessage.to?.text, currentMessage.cc?.text].filter(Boolean).join(", ");
        dispatch(composeEmail({
            guid: uuid(),
            to: currentMessage.from?.text || "",
            cc,
            subject: buildReplySubject(currentMessage.subject),
            body: buildQuotedReplyBody(currentMessage),
            header: "Reply All"
        }));
    };

    const handleForward = () => {
        dispatch(composeEmail({
            guid: uuid(),
            subject: buildForwardSubject(currentMessage.subject),
            body: buildForwardedBody(currentMessage),
            header: "Forward"
        }));
    };

    return(
    <div className={"previewPane"}>
        <ComponentLoading isActive={currentLoadingEvents > 0} />
        <h3>{emailTitle}</h3>
        {fromComponent}
        {currentMessage && <div className={"previewActions"}>
            <FontAwesomeIcon icon={ faReply } title="Reply" onClick={handleReply} />
            <FontAwesomeIcon icon={ faReplyAll } title="Reply All" onClick={handleReplyAll} />
            <FontAwesomeIcon icon={ faShare } title="Forward" onClick={handleForward} />
        </div>}
        {emailComponent}
    </div>)
}

export default PreviewPane;